export default [
  {
    path: '/fucionalidades',
    name: 'app-admin-menus',
    component: () => import('@/views/apps/fucionalidades-menus/fucionalidade-list/MenusList.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Menus',
      action: 'read',
      resource: 'ADMIN_B2C',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Fucionalidades',
          active: true,
        },
      ],
    },
  },
]
